import { render, staticRenderFns } from "./costComp.vue?vue&type=template&id=7ccb75f0&scoped=true&"
import script from "./costComp.vue?vue&type=script&lang=js&"
export * from "./costComp.vue?vue&type=script&lang=js&"
import style0 from "./costComp.vue?vue&type=style&index=0&id=7ccb75f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccb75f0",
  null
  
)

export default component.exports